{
  "fr": {
    "message": {
      "actions": {
        "delete_message": "Supprimer le message",
        "move_selected": "Déplacer les messages sélectionnés",
        "send": "Envoyer"
      },
      "labels": {
        "already_replied": "déjà répondu",
        "cannot_delete_message": "Les messages lus par les clients ne peuvent pas être supprimés",
        "changes_not_saved": "Vous avez des changements non enregistrés. Êtes-vous sur de vouloir continuer?\np.s.: Vous pouvez ouvrir un nouvel onglet pour naviguer vers d'autres pages simultanément.",
        "delete_message": "Ce message sera supprimé et ne pourra pas être récupéré",
        "delete_message_abort": "Le message ne peut pas être supprimé",
        "move_customer_notification": "Le client sera averti lorsque le message sera transféré vers une autre conversation",
        "move_to": "Déplacer le message vers...",
        "moved_here": "ici de la conversation",
        "moved_message": "a déplacé ce message",
        "moving_message": "Message émouvant",
        "notSeenYet": "Pas encore vue",
        "seen_by": "Vu par {participants}",
        "to": "à",
        "you": "tu"
      },
      "validation": {
        "message_required": "Message requis"
      }
    }
  }
}